
import { defineComponent } from 'vue'
import { iMetadata } from '../../DocumentExecution'
import { AxiosResponse } from 'axios'
import { downloadDirectFromResponse } from '@/helpers/commons/fileHelper'
import Dialog from 'primevue/dialog'
import Editor from 'primevue/editor'
import documentExecutionMetadataDialogDescriptor from './DocumentExecutionMetadataDialogDescriptor.json'
import KnInputFile from '@/components/UI/KnInputFile.vue'
import TabView from 'primevue/tabview'
import TabPanel from 'primevue/tabpanel'
import Textarea from 'primevue/textarea'

export default defineComponent({
    name: 'document-execution-metadata-dialog',
    components: { Dialog, Editor, KnInputFile, TabView, TabPanel, Textarea },
    props: {
        visible: { type: Boolean },
        propDocument: { type: Object },
        propMetadata: { type: Object, required: true },
        propLoading: { type: Boolean }
    },
    emits: ['close', 'saveMetadata'],
    data() {
        return {
            documentExecutionMetadataDialogDescriptor,
            document: null as any,
            metadata: null as iMetadata | null,
            uploadedFiles: {} as any,
            loading: false
        }
    },
    watch: {
        propMetadata() {
            this.loadDocument()
            this.loadMetadata()
        },
        propLoading() {
            this.setLoading()
        }
    },
    computed: {
        canModify(): boolean {
            return (this.$store.state as any).user.functionalities.includes('SaveMetadataFunctionality')
        }
    },
    created() {
        this.setLoading()
        this.loadDocument()
        this.loadMetadata()
    },
    methods: {
        loadDocument() {
            this.document = this.propDocument
        },
        loadMetadata() {
            if (this.propMetadata) {
                this.metadata = {
                    generalMetadata: this.propMetadata.GENERAL_META ? [...this.propMetadata.GENERAL_META] : [],
                    shortText: this.propMetadata.SHORT_TEXT ? [...this.propMetadata.SHORT_TEXT] : [],
                    longText: this.propMetadata.LONG_TEXT ? [...this.propMetadata.LONG_TEXT] : [],
                    file: this.propMetadata.FILE ? [...this.propMetadata.FILE] : []
                }

                if (this.metadata.file.length > 0) this.formatMetadataFileValues()
            }
        },
        formatMetadataFileValues() {
            if (!this.metadata) return
            this.metadata.file = this.metadata.file.map((file: any) => {
                return file
            })
        },
        setLoading() {
            this.loading = this.propLoading
        },
        uploadFile(event: any) {
            this.uploadedFiles[event.target.id] = event.target.files[0]
        },
        async uploadMetaFile(meta: any) {
            if (!this.uploadedFiles[meta.id]) {
                this.$store.commit('setError', {
                    title: this.$t('common.error.generic'),
                    msg: this.$t('documentExecution.main.selectFileError')
                })
            } else {
                this.loading = true

                const formData = new FormData()
                formData.append('file', this.uploadedFiles[meta.id])
                formData.append('fileName', this.uploadedFiles[meta.id].name)
                await this.$http
                    .post(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/documentexecution/uploadfilemetadata`, formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then(() => {
                        this.$store.commit('setInfo', {
                            title: this.$t('common.uploadFile'),
                            msg: this.$t('common.uploadFileSuccess')
                        })
                        this.updateMetadataFile(meta.id, this.uploadedFiles[meta.id].name)
                    })
                    .catch((error: any) =>
                        this.$store.commit('setError', {
                            title: this.$t('common.error.generic'),
                            msg: error
                        })
                    )
                this.loading = false
            }
        },
        updateMetadataFile(fileId: number, fileName: string) {
            if (!this.metadata) return
            const index = this.metadata?.file.findIndex((tempFile: any) => tempFile.id === fileId)
            if (index !== -1) {
                this.metadata.file[index].fileToSave = { file: {}, fileName: fileName }
                if (this.metadata.file[index].value) this.metadata.file[index].value = ''
            }
        },
        cleanFile(meta: any) {
            const temp = this.$refs[meta.id] as any
            if (temp && this.metadata) {
                temp.resetInput()
                delete this.uploadedFiles[meta.id]
                const index = this.metadata.file.findIndex((tempFile: any) => tempFile.id === meta.id)
                if (index !== -1) {
                    delete this.metadata.file[index].fileToSave
                    this.metadata.file[index].value = ''
                }
            }
        },
        async downloadFile(meta: any) {
            if (!meta.value) return

            await this.$http
                .get(process.env.VUE_APP_RESTFUL_SERVICES_PATH + `1.0/documentexecution/${this.document.id}/${meta.id}/documentfilemetadata`, {
                    headers: {
                        Accept: 'application/json, text/plain, */*'
                    },
                    responseType: 'blob'
                })
                .then((response: AxiosResponse<any>) => {
                    downloadDirectFromResponse(response)
                    this.$store.commit('setInfo', {
                        title: this.$t('common.toast.success')
                    })
                })
                .catch((error: any) => {
                    this.$store.commit('setError', {
                        title: this.$t('common.error.generic'),
                        msg: error
                    })
                })
        },
        closeDialog() {
            this.metadata = null
            this.$emit('close')
            this.uploadedFiles = {}
        },
        save() {
            this.$emit('saveMetadata', this.metadata)
            this.uploadedFiles = {}
        }
    }
})
